"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.USER_COMPANY_EMPLOYEE_ENDPOINT = {
    getIsInvitationValid: '/user-company/{{version}}/employees/{{inviteeUuid}}/{{inviteeToken}}/validate-invite',
    postInviteAnEmployee: '/user-company/{{version}}/employees/{{adminUuid}}/invites',
    postCreateAnEmployeeFromInvite: '/user-company/{{version}}/employees/invite/{{inviteeToken}}',
    toggleActiveEmployee: '/user-company/{{version}}/employees/{{employeeUuid}}/deactivate',
};
